module.exports = __webpack_public_path__ + "img/Illustration-Upload Border.d13a14a8.svg";